export default "__VITE_ASSET__bae2921c__"